import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
import 'swiper/css'

export default () => ({
    swiper: null,

    init() {
        const root = this.$el
        const titleEl = document.getElementById('project-title')

        const swiperEl = root.querySelector('.projects-swiper')
        const nextEl = root.querySelector('.swiper-next')
        const prevEl = root.querySelector('.swiper-prev')

        // на всякий случай: если чего-то нет — не падаем
        if (!swiperEl) return

        this.swiper = new Swiper(swiperEl, {
            modules: [Navigation],
            loop: true,
            speed: 500,

            navigation: {
                nextEl,
                prevEl,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.05,
                    spaceBetween: 5
                },
                768: {
                    slidesPerView: 1
                }
            },
            on: {
                init: (swiper) => {
                    if (!titleEl) return
                    const slide = swiper.slides[swiper.activeIndex]
                    titleEl.textContent = slide?.dataset?.title ?? ''
                },
                slideChange: (swiper) => {
                    if (!titleEl) return
                    const slide = swiper.slides[swiper.activeIndex]
                    titleEl.textContent = slide?.dataset?.title ?? ''
                },
            },
        })
    },
})
